import getSymbolFromCurrency from 'currency-symbol-map';

export default function getPriceFormat (pd, plan){
    const frequencyMap = {
        MONTH : 'month',
        YEAR : 'year',
        DAY : 'day',
        WEEK: 'week'
      }
	return ' '+getSymbolFromCurrency(pd.recurringPaymentCurrencyCode)+''+pd.recurringPaymentAmount+'/'+ (plan.renewalCyclePeriodMultiplier > 1 ?  plan.renewalCyclePeriodMultiplier : '') + frequencyMap[plan.renewalCycleType] + (plan.renewalCyclePeriodMultiplier > 1 ? 's' : '')+' '
 }